import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPageLoading,
  finishPageLoading,
} from "./redux/slices/loadingSlice";
import { loadFavorites } from "./redux/slices/favoritesSlice";
import { changeNumberOfPages, loadPosts } from "./redux/slices/postsSlice";
import LoadingScreen from "./components/LoadingScreen";
import ContentContainer from "./components/ContentContainer";
import Header from "./components/Header";
import Posts from "./components/Posts";
import Community from "./components/Community";
import Challenges from "./components/Challenges";
import Tools from "./components/Tools";
import Footer from "./components/Footer";
import "./styles/App.scss";

function App() {
  const pageLoading = useSelector(selectPageLoading);

  const dispatch = useDispatch();

  useEffect(() => {
    const initializePageData = async () => {
      const baseURL = process.env.REACT_APP_SERVER_URL;

      const favoritesRes = await fetch(`${baseURL}/api/favorites`);
      const favorites = await favoritesRes.json();
      dispatch(loadFavorites(favorites));

      // check for number of posts in database
      const postsCountRes = await fetch(`${baseURL}/api/posts/count`);
      const postsCount = await postsCountRes.json();

      const numberOfPages = Math.ceil(postsCount / 4);
      dispatch(changeNumberOfPages(numberOfPages));

      // fetch latest 4 posts
      const postsRes = await fetch(`${baseURL}/api/posts`);
      const posts = await postsRes.json();
      dispatch(loadPosts(posts));

      // stop page loading after 1s so that the images will be loaded
      setTimeout(() => dispatch(finishPageLoading()), 1000);
    };

    initializePageData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      {pageLoading && <LoadingScreen />}

      <Header />

      <ContentContainer>
        <main>
          <Posts />

          <Community />

          <Challenges />

          <Tools />
        </main>

        <Footer />
      </ContentContainer>
    </Fragment>
  );
}

export default App;
